import {
  getLeoDate,
  LeoDate,
  getObject,
  getList,
} from "@surya-digital/leo-ts-types";
import { TimeOfDay, TimeOfDayDTO } from "./timeOfDay";
import { DayOfWeek } from "./dayOfWeek";


export namespace ScheduleType {
  export interface ImmediateDTO {
    case: string;
  }
  
  export class Immediate {
    readonly isScheduleTypeImmediate: boolean = true;
  
  
  
  
  
    toDTO(): ImmediateDTO {
      const dto: ImmediateDTO = {
        case: "IMMEDIATE",
      };
      return dto;
    }
    }
  
  Immediate.prototype.toString = function toString(): string {
    return `ScheduleType.IMMEDIATE()`;
  };
  
  export interface SingleTimeDTO {
    case: string;
    date: string;
    time: TimeOfDayDTO;
  }
  
  export class SingleTime {
    readonly isScheduleTypeSingleTime: boolean = true;
  
    readonly date: LeoDate;
    readonly time: TimeOfDay;
  
  
    constructor(
    date: LeoDate, 
    time: TimeOfDay
    ) {
      this.date = date;
      this.time = time;
    }
  
    static fromDTO(dto: SingleTimeDTO): SingleTime {
      const date = getLeoDate(dto, "date", InvalidScheduleTypeSingleTimeDateError);
      const time = TimeOfDay.fromDTO(getObject(dto, "time", InvalidScheduleTypeSingleTimeTimeError));
      return new SingleTime(
        date,
        time
      );
    }
  
    toDTO(): SingleTimeDTO {
      const dto: SingleTimeDTO = {
        case: "SINGLE_TIME",
          date: this.date.toDTO(),
          time: this.time.toDTO()
      };
      return dto;
    }
    }
  
  SingleTime.prototype.toString = function toString(): string {
    return `ScheduleType.SINGLE_TIME(date='${this.date}',time='${this.time}')`;
  };
  
  export interface RecurringDTO {
    case: string;
    startDate: string;
    endDate: string;
    daysOfWeek: DayOfWeek.DayOfWeekDTO[];
    timeOfDay: TimeOfDayDTO;
  }
  
  export class Recurring {
    readonly isScheduleTypeRecurring: boolean = true;
  
    readonly startDate: LeoDate;
    readonly endDate: LeoDate;
    readonly daysOfWeek: DayOfWeek.DayOfWeek[];
    readonly timeOfDay: TimeOfDay;
  
  
    constructor(
    startDate: LeoDate, 
    endDate: LeoDate, 
    daysOfWeek: DayOfWeek.DayOfWeek[], 
    timeOfDay: TimeOfDay
    ) {
      this.startDate = startDate;
      this.endDate = endDate;
      this.daysOfWeek = daysOfWeek;
      this.timeOfDay = timeOfDay;
    }
  
    static fromDTO(dto: RecurringDTO): Recurring {
      const startDate = getLeoDate(dto, "startDate", InvalidScheduleTypeRecurringStartDateError);
      const endDate = getLeoDate(dto, "endDate", InvalidScheduleTypeRecurringEndDateError);
      const daysOfWeek = getList<DayOfWeek.DayOfWeekDTO, DayOfWeek.DayOfWeek>(
        dto,
        "daysOfWeek",
        DayOfWeek.fromDTO,
        InvalidScheduleTypeRecurringDaysOfWeekError
      );
      const timeOfDay = TimeOfDay.fromDTO(getObject(dto, "timeOfDay", InvalidScheduleTypeRecurringTimeOfDayError));
      return new Recurring(
        startDate,
        endDate,
        daysOfWeek,
        timeOfDay
      );
    }
  
    toDTO(): RecurringDTO {
      const dto: RecurringDTO = {
        case: "RECURRING",
          startDate: this.startDate.toDTO(),
          endDate: this.endDate.toDTO(),
          daysOfWeek: this.daysOfWeek.map((e: DayOfWeek.DayOfWeek) => { return DayOfWeek.toDTO(e); }),
          timeOfDay: this.timeOfDay.toDTO()
      };
      return dto;
    }
    }
  
  Recurring.prototype.toString = function toString(): string {
    return `ScheduleType.RECURRING(startDate='${this.startDate}',endDate='${this.endDate}',daysOfWeek='${this.daysOfWeek}',timeOfDay='${this.timeOfDay}')`;
  };
  

  export type ScheduleType = Immediate | SingleTime | Recurring;

  export type ScheduleTypeDTO = ImmediateDTO | SingleTimeDTO | RecurringDTO;

  export const fromDTO = (dto: ScheduleTypeDTO): ScheduleType => {
    switch (dto.case) {
      case "IMMEDIATE":
          return new Immediate();
      case "SINGLE_TIME":
          return SingleTime.fromDTO(dto as SingleTimeDTO);
      case "RECURRING":
          return Recurring.fromDTO(dto as RecurringDTO);
      default:
        throw new InvalidScheduleTypeError(
            `Case ${dto.case} is not valid case of ScheduleType.`
        );
    }
  };
}

export class InvalidScheduleTypeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeError";
  }
}
export class InvalidScheduleTypeImmediateError extends InvalidScheduleTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeImmediateError";
  }
}

export class InvalidScheduleTypeSingleTimeError extends InvalidScheduleTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeSingleTimeError";
  }
}

export class InvalidScheduleTypeSingleTimeDateError extends InvalidScheduleTypeSingleTimeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeSingleTimeDateError";
  }
}

export class InvalidScheduleTypeSingleTimeTimeError extends InvalidScheduleTypeSingleTimeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeSingleTimeTimeError";
  }
}

export class InvalidScheduleTypeRecurringError extends InvalidScheduleTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeRecurringError";
  }
}

export class InvalidScheduleTypeRecurringStartDateError extends InvalidScheduleTypeRecurringError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeRecurringStartDateError";
  }
}

export class InvalidScheduleTypeRecurringEndDateError extends InvalidScheduleTypeRecurringError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeRecurringEndDateError";
  }
}

export class InvalidScheduleTypeRecurringDaysOfWeekError extends InvalidScheduleTypeRecurringError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeRecurringDaysOfWeekError";
  }
}

export class InvalidScheduleTypeRecurringTimeOfDayError extends InvalidScheduleTypeRecurringError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidScheduleTypeRecurringTimeOfDayError";
  }
}
